// extracted by mini-css-extract-plugin
export default {"documentDetails":"DocumentDetails_documentDetails__Kx5xf"};